
import { Component } from "vue-property-decorator";
import { Console } from "@/common/global.ts";
import BaseView from "@/common/base-view.ts";
import Store from "@/store";

/**
 * Base Page
 */
@Component
export default class BasePage extends BaseView {

    /**
     * [name description]
     *
     * @type {[type]}
     */
    public name: string = "page/base";

    /**
     * [created description]
     *
     * @return {[type]} [description]
     */
    public created() {
        //
    }

    /**
     * [mounted description]
     *
     * @return {[type]} [description]
     */
    public mounted() {
        super.mounted();

        // Set current page to this class
        Store.state.page = <IBasePage> <unknown> this;
    }

    /**
     * [destroyed description]
     *
     * @return {[type]} [description]
     */
    public destroyed() {
        super.destroyed();
    }

    /**
     * [setPageName description]
     */
    public setPageName() {
        this.$el.className = (this.$el.className || "").replace(/\bpage\-.*?\b/g, "");
        document.body.classList.add(this.name.replace("/", "-"));
    }

    /**
     * [AnimateIn description]
     */
    public AnimateIn(onComplete: any = null) {
        super.AnimateIn(onComplete);
        this.setPageName();
    }

    /**
     * [beforeRouteEnter description]
     *
     * @param  {[type]}   to   [description]
     * @param  {[type]}   from [description]
     * @param  {Function} next [description]
     *
     * @return {[type]}        [description]
     */
    public beforeRouteEnter(to: IRouterDirection, from: IRouterDirection, next: () => void) {
        next();

        setTimeout(() => {
            if (Store.state.page) {
                Store.state.page.AnimateIn();
            }
        }, 1);
    }

    /**
     * [beforeRouteLeave description]
     *
     * @param  {[type]}   to   [description]
     * @param  {[type]}   from [description]
     * @param  {Function} next [description]
     *
     * @return {[type]}        [description]
     */
    public beforeRouteLeave(to: IRouterDirection, from: IRouterDirection, next: () => void) {
        this.AnimateOut(next);
    }

    /**
     * [log description]
     *
     * @param  {...[type]} params [description]
     *
     * @return {[type]}           [description]
     */
    public log(...params: any[]) {
        Console.color("[" + this.name + "] " + params.join(" | "), {
            background: "#1D3461",
            color: "#B1D0EC",
        });
    }

}
